import * as React from "react";
import { Accordion } from "../../../react-core/Html/Accordion";
import { FooterContents } from "../Resoures/Contents";

export const SecuredFooter = () => {
    const [providerLinkExpanded, setProviderLinkExpanded] = React.useState<boolean>(false);
    return (
        <footer className="footer no-print">
            <ul className="footer-links">
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.abrdn.com/en-gb/platform-adviser/wrap/platform-help-centre"
                        role="link"
                    >
                        Help and guides
                    </a>
                </li>
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.abrdn.com/en-gb/platform-adviser/wrap/contact"
                        role="link"
                    >
                        Contact us
                    </a>
                </li>
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.abrdn.com/en-gb/corporate/cookie-policy"
                        role="link"
                    >
                        Cookie policy
                    </a>
                </li>
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.abrdn.com/en-gb/platform-adviser/privacy"
                        role="link"
                    >
                        Privacy policy
                    </a>
                </li>
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.abrdn.com/en-gb/platform-adviser/legal"
                        role="link"
                    >
                        Legal information
                    </a>
                </li>
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.abrdn.com/en-gb/platform-adviser/accessibility"
                        role="link"
                    >
                        Accessibility
                    </a>
                </li>
            </ul>
            <div className="row">
                <Accordion label={FooterContents.WebsiteBrandAndProviderDetails} cssWrapper={"accordion-simple"}>
                    <div className="row">
                        <div className="col-12 col-md-8">
                            <div className="footer-content">
                                <p>{FooterContents.ProviderDetailsParagraph}</p>
                                <p>
                                    {FooterContents.ProviderDetailsParagraph4}
                                    <a className="hyperlink" target="_blank" href="https://www.abrdn.com">
                                        {FooterContents.ProviderDetailsParagraph4Link}
                                    </a>
                                </p>
                                <p>{FooterContents.ProviderDetailsParagraph5}</p>
                            </div>
                        </div>
                    </div>
                </Accordion>
            </div>
        </footer>
    );
};
